
interface LogoProps {
  className?: string;
}

export default function Logo({ className = "h-12 w-auto" }: LogoProps) {
  return (
    <img
      src="/logo-bonus.png"
      alt="App Bônus - prof. Vinicius"
      className={className}
    />
  );
}
